import axios from "axios";
import { environment } from "../../../environments/environment";

export function getFinanceInfo(partId) {
    return axios.get(`${environment.getFinanceInfo}?partId=${partId}`,);
}

export function getGlAccountInfo(partId) {
    return axios.get(`${environment.getGlAccountsInfo}?partId=${partId}`);
}

export function createGlPartInfo(info, partId){
    return axios.post(`${environment.saveGlPartInfo}?partId=${partId}`, info);
}

export function updateGlPartInfo(info, partId){
    return axios.put(`${environment.saveGlPartInfo}?partId=${partId}`, info);
}